module.exports = __webpack_public_path__ + "img/type--1-spans--multiple-lang--en.c3936539.jpg";